var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgPlaceholderGray(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0714 1.33301H1.9285C1.57346 1.33301 1.28564 1.63148 1.28564 1.99967V13.9997C1.28564 14.3679 1.57346 14.6663 1.9285 14.6663H16.0714C16.4264 14.6663 16.7142 14.3679 16.7142 13.9997V1.99967C16.7142 1.63148 16.4264 1.33301 16.0714 1.33301Z",
    fill: "#F8F8F8",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33155 7.13765L1.28613 11.3329L2 11.3946V14H16V12.6045L16.7147 12.6662L13.3121 9.13764C13.2524 9.07574 13.1816 9.02663 13.1036 8.99313C13.0256 8.95963 12.942 8.94238 12.8575 8.94238C12.7731 8.94238 12.6895 8.95963 12.6115 8.99313C12.5335 9.02663 12.4627 9.07574 12.403 9.13764L10.7407 10.8615C10.681 10.9234 10.6101 10.9725 10.5321 11.006C10.4541 11.0395 10.3705 11.0568 10.2861 11.0568C10.2017 11.0568 10.1181 11.0395 10.0401 11.006C9.96212 10.9725 9.89125 10.9234 9.83155 10.8615L6.24069 7.13765C6.181 7.07574 6.11013 7.02663 6.03213 6.99313C5.95414 6.95963 5.87054 6.94238 5.78612 6.94238C5.7017 6.94238 5.61811 6.95963 5.54011 6.99313C5.46212 7.02663 5.39125 7.07574 5.33155 7.13765Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7C12.3284 7 13 6.32843 13 5.5C13 4.67157 12.3284 4 11.5 4C10.6716 4 10 4.67157 10 5.5C10 6.32843 10.6716 7 11.5 7Z",
    fill: "#C4C4C4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholderGray);
export default __webpack_public_path__ + "static/media/img-placeholder-gray.f6c63468afba012bff64286ae44d774c.svg";
export { ForwardRef as ReactComponent };